import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { type ReactElement, useId } from 'react';
import { useTranslation } from 'react-i18next';

import { SectionHeader } from '../../components/SectionHeader';

/**
 * The language section (S8 R11, R12): the active language, which follows Telegram, read-only.
 * The FR · EN selector of the mockup waits for Q26: no control here, and nothing calls
 * `PUT /me/preferences`.
 */
export function LanguageSection(): ReactElement {
  const { t } = useTranslation();
  const headingId = useId();
  return (
    <Box component="section" aria-labelledby={headingId}>
      <SectionHeader id={headingId} title={t('account.language.heading')} />
      <Paper variant="outlined" sx={{ p: 2, borderRadius: 3 }}>
        <Typography sx={{ fontWeight: 600 }}>{t('account.language.current')}</Typography>
        <Typography sx={{ color: 'text.secondary', fontSize: 14 }}>
          {t('account.language.note')}
        </Typography>
      </Paper>
    </Box>
  );
}
